var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('en_header'),_c('router-view'),_c('en_footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }